import React, { useEffect, useState } from 'react'
import { Input } from './Input'

export default function Header() {
    const [memberInfo, setMemberInfo] = useState(null)

    useEffect(() => {
        let mounted = true
        const fetchMember = async () => {
            try {
                const res = await fetch('https://api.cn/api/member/getMemberInfo/', { 
                    credentials: 'include' 
                })
                if (!res.ok) return
                const result = await res.json()
                const data = result && result.status && result.data
                console.log('Member info:', data)
                if (mounted) setMemberInfo(data)
            } catch (e) {
                console.error('Failed to fetch member info', e)
            }
        }
        fetchMember()
        return () => { mounted = false }
    }, [])

    const getDisplayName = (u) => {
        if (!u) return ''
        return u.nickname || u.name || u.username || '已登陆用户'
    }

    return (
        <header className="max-w-screen-2xl mx-auto rounded-2xl shadow-md bg-white text-black mb-8">
            <div className="max-w-screen-2xl mx-auto flex items-center gap-4 px-6 py-3">
                <div className="flex items-center gap-3">
                    <a href="https://api.cn/">
                        <div className="text-2xl h-[60px] flex items-center justify-center overflow-hidden">
                            <img src="https://api.cn/static/www/image/public/logo.png" alt="APi云市场" width="200" height="125"/>
                        </div>
                    </a>
                </div>

                <div className="flex-1 flex justify-center">
                    <form className="w-full max-w-lg" onSubmit={(e) => { e.preventDefault(); const v = (e.target.keyword && e.target.keyword.value || '').trim(); const url = v ? `https://api.cn/search/?keyword=${encodeURIComponent(v)}` : '/search/'; window.location.href = url; }}>
                        <div className="flex">
                            <Input
                                name="keyword"
                                placeholder="搜索服务名称"
                                aria-label="搜索服务名称"
                                className="flex-1 bg-gray-600/20 placeholder-gray-600 border-transparent focus:ring-0 focus:border-gray-300"
                            />
                            <button type="submit" className="ml-2 px-3 py-2 bg-gray-600/20 hover:bg-gray-700/20 rounded-md">搜索</button>
                        </div>
                    </form>
                </div>

                <div className="flex items-center gap-4 text-sm">
                    <a className="hover:underline cursor-pointer" href="https://api.cn/contact/">联系我们</a>
                    <a className="hover:underline cursor-pointer" href="https://api.cn/market/">API接口大全</a>
                    <a className="hover:underline cursor-pointer" href='https://sp.api.cn/'>商户入驻</a>
                    {memberInfo ? (
                        <div className="ml-2 flex items-center gap-2 cursor-pointer">
                            <div className="text-sm">{getDisplayName(memberInfo)} </div>
                        </div>
                    ) : (
                        <a className="ml-2 hover:underline cursor-pointer" href='https://api.cn/#login'>登录</a>
                    )}
                </div>
            </div>
        </header>
    )
}
